import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { CircleCheck as CheckCircle2, Factory, HardHat, Lightbulb, Phone, MapPin, Settings, Users } from 'lucide-react';
const products = [{
  name: "Underground mining equipment"
}, {
  name: "Crushers and vibrating feeders"
}, {
  name: "High-density solids, concrete, and mortar pumps"
}, {
  name: "Welding machines and consumables"
}, {
  name: "Pumps and piping systems"
}, {
  name: "LED lighting"
}, {
  name: "Switchboards and electrical components"
}, {
  name: "Protective coatings"
}, {
  name: "Demarcation lighting"
}];
const industries = [{
  name: "Flue gas desulfurization",
  icon: Factory
}, {
  name: "Water treatment",
  icon: Settings
}, {
  name: "Petrochemical",
  icon: Factory
}, {
  name: "Oil and gas",
  icon: Factory
}, {
  name: "Copper mines",
  icon: HardHat
}, {
  name: "Gold mines",
  icon: HardHat
}, {
  name: "Nickel mines",
  icon: HardHat
}, {
  name: "Platinum mines",
  icon: HardHat
}];
const services = [{
  title: "Consulting",
  description: "Working alongside mines and processing plants to develop custom-tailored equipment frameworks.",
  icon: Users
}, {
  title: "Installation & Maintenance",
  description: "Assisting clients with complex equipment setups and routine maintenance tasks to eliminate costly downtime.",
  icon: Settings
}, {
  title: "Personnel Training",
  description: "Providing structured on-site training during installations to ensure that operators can use all supplied equipment safely and effectively.",
  icon: Lightbulb
}];
export default function CompanyOverview() {
  return <section id="company-overview" className="bg-background ![padding:20px_0px_0px_0px]">
      <div className="page-container">
        {}
        <div className="max-w-4xl mx-auto text-center mb-20">
          <h2 className="font-black uppercase tracking-tighter mb-8 text-primary !text-[45px]">About THE LEADS</h2>
          <div className="space-y-6 text-lg md:text-xl leading-relaxed text-foreground/80">
            <p className="!font-sans !text-[rgba(0,70,84,1)] !text-base !font-medium">The Leads has established itself as a trusted supplier of mining equipment and key facility services in South Africa, ensuring the safety and reliability of the operational equipment used. We work closely with our clients to deliver tailored solutions that fit the specific needs of their facilities, whether they require welding, high-capacity pumps, underground mining equipment, or specialised maintenance.</p>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_operations_overview.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_operations_overview.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_operations_overview.png-wvc-sizes" alt="Mining operations overview" className="w-full rounded-lg shadow-md object-cover max-h-[400px]" loading="lazy" decoding="async" src="https://theleads.co.za/wp-content/uploads/2026/06/AdobeStock_1875314339-scaled.jpeg" />
            
          </div>
        </div>

        {}
        


        {}
        <div className="mb-24">
          <div className="text-center mb-12">
            
            <h3 className="text-3xl font-bold text-primary mb-4">VALUE-ADDED SERVICES</h3>
            <p className="max-w-2xl mx-auto !font-sans !text-[rgba(0,70,84,1)] !font-medium">
              As a comprehensive supplier, our team offers an array of professional services to complement our physical equipment.
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            {services.map((service, i) => {
            const Icon = service.icon;
            return <div key={i} data-index={i} className="bg-card p-8 rounded-lg shadow-md border border-border hover:shadow-lg transition-shadow">
                  <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mb-6">
                    <Icon className="size-6 text-primary" />
                  </div>
                  <h4 className="text-xl font-bold mb-4 text-primary">{service.title}</h4>
                  <p className="text-foreground/70 leading-relaxed">
                    {service.description}
                  </p>
                </div>;
          })}
          </div>
          <div className="mt-12">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_technical_services.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_technical_services.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_technical_services.png-wvc-sizes" alt="Mining technical services" className="w-full rounded-lg shadow-lg object-cover max-h-[350px] !h-[700px]" loading="lazy" decoding="async" src="https://theleads.co.za/wp-content/uploads/2026/06/AdobeStock_858891368-scaled.jpeg" src="https://theleads.co.za/wp-content/uploads/2026/06/AdobeStock_1863556472-1-scaled.jpeg" src="https://theleads.co.za/wp-content/uploads/2026/06/AdobeStock_1863556472-scaled.jpeg" src="https://theleads.co.za/wp-content/uploads/2026/06/AdobeStock_1841613252-scaled.jpeg" />
          </div>
        </div>

        {}
        
      </div>
    </section>;
}